import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
export class TraitRegistryStage extends TraitRegistryCategory {
    label = 'Stage';
    constructor(parent) {
        super(parent);
        super.init();
    }
    aspectRatio = () => new TraitTypeSelect({
        default: 1,
        select: [
            [0.75, '3:4'],
            [1, '1:1'],
            [4 / 3, '4:3'],
            [1.5, '3:2'],
            [16 / 10, '16:10'],
            [16 / 9, '16:9'],
        ],
    });
}
